<template>
	<v-form
		ref="form"
		v-model="valid"
		@submit.prevent=""
	>
		<v-layout
			row
			wrap
			ma-0
			justify-center
			align-center
		>
			<v-flex
				xs12
				py-0
			>
				<v-text-field
					v-model="name"
					:rules="[
						...validate.require,
						validate.max(name, 35),
						validateCheckDuplicates(name, outputNames)
					]"
					name="Name"
					label="Name *"
					autofocus
				/>
			</v-flex>
			<v-flex
				xs12
				class="text-xs-left"
				pt-0
			>
				<OutputSettings
					ref="outputSettings"
					:disabled="!valid"
					@output-settings="submit"
				>
					<template slot="additional-actions">
						<v-btn
							flat
							color="error"
							@click="close()"
						>
							close
						</v-btn>
					</template>
				</OutputSettings>
			</v-flex>
		</v-layout>
	</v-form>
</template>

<script>
import OutputSettings from '@/components/Report/OutputSettings';
import Validation from '@/mixins/Validation';

export default {
	components: {
		OutputSettings,
	},
	mixins: [Validation],
	data() {
		return {
			valid: false,
			name: '',
		};
	},
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		outputNames() {
			return this.project.outputs.map(output => output.name);
		},
	},
	methods: {
		reset() {
			this.$refs.form.reset();
			this.$refs.outputSettings.reset();
		},
		close() {
			this.reset();
			this.$emit('close');
		},
		submit(settings) {
			const model = settings;

			model.name = this.name;
			model.projectId = this.project.id;
			model.save().then(() => {
				this.project.outputs.unshift(model);
				this.$notify('success', `Output "${model.name}" has been created.`);
				this.reset();
				this.$emit('new', model);
			}).catch(() => {
				this.$notify('error', 'Failed to add output');
			}).finally(() => {
				this.$emit('close');
			});
		},
	},
};
</script>

<style>

</style>
